module.exports = __webpack_public_path__ + "img/xiaohai.18ebcaac.png";